import { render, staticRenderFns } from "./CheckBeforeSort.vue?vue&type=template&id=01d7f398&scoped=true&"
import script from "./CheckBeforeSort.vue?vue&type=script&lang=js&"
export * from "./CheckBeforeSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d7f398",
  null
  
)

export default component.exports